import { Button } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { ButtonContainer } from "./Profile.sc";

interface LoadLessButtonProps {
    onLoadLess: () => void;
}

const LoadLessButton: React.FunctionComponent<LoadLessButtonProps> = ({ onLoadLess }) => {
    const { t } = useTranslation();
    return (
        <ButtonContainer>
            <Button onClick={onLoadLess}>{t("show_less")}</Button>
        </ButtonContainer>
    );
};

export default LoadLessButton;
